    <div class="mainContainer">
    <div class="headingContainer">
        <span style="font-weight: 600; font-size:18px;">{{facility_name}}</span>
        <i [mat-dialog-close]="true" class="fa fa-times closeIcon" aria-hidden="true"></i>
    </div>

    <div class="main">
        <div style="font-weight: 600; margin-bottom:20px;">
            <div *ngIf="receiptLink?.length >= 1" style="font-size:14px;">
                <span style="margin-right: 4px;">Find Uploaded</span>
                <span *ngIf="receiptLink?.length <=1">Receipt</span>
                <span *ngIf="receiptLink?.length >=2">Receipts</span>
                <span style="margin-left: 4px;">Below</span>
            </div>

            <div *ngIf="receiptLink?.length < 1" class="noReceiptContainer">
                <img src="assets/images/no-data-found.svg" alt="No Data Found" width="250px" height="250px">
                <span class="label">No Receipt Uploaded Yet</span>
            </div>
        </div>

        <div *ngIf="receiptLink?.length" class="receiptContainer">
            <div *ngFor="let imgLink of receiptLink" style="margin-top:10px;">
                <img src={{imgLink}} width="450" height="400">
            </div>
        </div>

        <div *ngIf="showApproveCard" class="amountApproveCard  pt-4 pb-2">
            <i class="fa fa-times closeCard" (click)="closeApproveCard()" aria-hidden="true"></i>
            <div class="labelText">Enter Amount To Approve</div>
            <!-- <div class="asterisk">*</div> -->
            <input type="number" [(ngModel)]="amountApprove" class="amountApprove" placeholder="Approve Amount" />

            <div class="labelText mt-2">Remark (Optional)</div>
            <textarea [(ngModel)]="paymentRemark" placeholder="Add A Remark" rows="1" class="rejectReason"></textarea>
            <div style="display: flex; justify-content:end; margin-top:15px;">
                <button (click)="submitApproveAmount()" class="submit">Submit</button>
            </div>
        </div>

        <div *ngIf="showRejectCard" class="rejectReasonCard pt-4 pb-2">
            <i class="fa fa-times closeCard" (click)="closeRejectCard()" aria-hidden="true"></i>
            <div class="labelText">Please Enter Reason of Rejection</div>
            <!-- <div class="asterisk">*</div> -->
            <textarea [(ngModel)]="rejectReason" placeholder="Enter Reason Of Rejection" rows="1"
                class="rejectReason"></textarea>
            <div style="display: flex; justify-content:end; margin-top:15px;">
                <button (click)="submitRejectReason()" class="submit">Submit</button>
            </div>
        </div>

        <div *ngIf="!showApproveCard && !showRejectCard && receiptLink?.length && approvalPending" class="btnContainer">
            <button class="approveBtn"
                (click)="showApproveCard = !showApproveCard; showRejectCard = false">APPROVE</button>
            <button class="rejectBtn"
                (click)="showRejectCard = !showRejectCard; showApproveCard = false">REJECT</button>
        </div>
        <!-- {{approvalPending}}{{receiptLink?.length}} -->
        <div *ngIf="!approvalPending && receiptLink?.length >= 1" class="label"
            style="margin-top: 15px; text-align:center;">
            No Amount Pening For Approval
        </div>
    </div>
</div>